"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadLocale = loadLocale;
var _en = _interopRequireDefault(require("./en"));
var _fr = _interopRequireDefault(require("./fr"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var supportedLocales = {
  en: _en["default"],
  fr: _fr["default"]
};
var defaultLocale = 'en';
function loadLocale(code) {
  return supportedLocales[code] ? supportedLocales[code] : supportedLocales[defaultLocale];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfZW4iLCJfaW50ZXJvcFJlcXVpcmVEZWZhdWx0IiwicmVxdWlyZSIsIl9mciIsImUiLCJfX2VzTW9kdWxlIiwic3VwcG9ydGVkTG9jYWxlcyIsImVuIiwiZW5NZXNzYWdlcyIsImZyIiwiZnJNZXNzYWdlcyIsImRlZmF1bHRMb2NhbGUiLCJsb2FkTG9jYWxlIiwiY29kZSJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9sb2NhbGUvaW5kZXguanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGVuTWVzc2FnZXMgZnJvbSAnLi9lbic7XG5pbXBvcnQgZnJNZXNzYWdlcyBmcm9tICcuL2ZyJztcblxuY29uc3Qgc3VwcG9ydGVkTG9jYWxlcyA9IHtlbjogZW5NZXNzYWdlcywgZnI6IGZyTWVzc2FnZXN9O1xuY29uc3QgZGVmYXVsdExvY2FsZSA9ICdlbic7XG5cbmV4cG9ydCBmdW5jdGlvbiBsb2FkTG9jYWxlKGNvZGUpIHtcbiAgICByZXR1cm4gc3VwcG9ydGVkTG9jYWxlc1tjb2RlXSA/IHN1cHBvcnRlZExvY2FsZXNbY29kZV0gOiBzdXBwb3J0ZWRMb2NhbGVzW2RlZmF1bHRMb2NhbGVdO1xufSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsSUFBQUEsR0FBQSxHQUFBQyxzQkFBQSxDQUFBQyxPQUFBO0FBQ0EsSUFBQUMsR0FBQSxHQUFBRixzQkFBQSxDQUFBQyxPQUFBO0FBQThCLFNBQUFELHVCQUFBRyxDQUFBLFdBQUFBLENBQUEsSUFBQUEsQ0FBQSxDQUFBQyxVQUFBLEdBQUFELENBQUEsZ0JBQUFBLENBQUE7QUFFOUIsSUFBTUUsZ0JBQWdCLEdBQUc7RUFBQ0MsRUFBRSxFQUFFQyxjQUFVO0VBQUVDLEVBQUUsRUFBRUM7QUFBVSxDQUFDO0FBQ3pELElBQU1DLGFBQWEsR0FBRyxJQUFJO0FBRW5CLFNBQVNDLFVBQVVBLENBQUNDLElBQUksRUFBRTtFQUM3QixPQUFPUCxnQkFBZ0IsQ0FBQ08sSUFBSSxDQUFDLEdBQUdQLGdCQUFnQixDQUFDTyxJQUFJLENBQUMsR0FBR1AsZ0JBQWdCLENBQUNLLGFBQWEsQ0FBQztBQUM1RiIsImlnbm9yZUxpc3QiOltdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/pm-js/build/locale/index.js
// module id = ./node_modules/pm-js/build/locale/index.js
// module chunks = main